var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReAssignDriver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 264.82 287.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9a4800;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.19,184.56c-34.18,0-65.09,20.55-77.92,51.66-1.39,3.37-1.31,5.23,1.75,7.85,11.71,10,9.14,29.95-5.14,35.58-9.6,3.78-20.06,5.9-30.33,7.3-9.84,1.34-15.61-3.38-18.46-13C-1.62,261.5.36,249,2.3,236.48c4.69-30.22,21.93-51.71,47-67.76a152.88,152.88,0,0,1,43.58-19.19,8.89,8.89,0,0,1,6.26,1c22,13.66,43.76,13.64,65.63-.16,1.38-.88,3.49-1.7,4.9-1.3,29.25,8.45,55.87,21.5,75.3,45.87,17.21,21.6,22.1,46.86,19,73.7-1.75,15.24-10.48,21-25.51,18.09-7-1.35-13.91-3.19-20.76-5.18-8.17-2.37-13.49-7.95-15.17-16.25s.45-16,7.34-21.46c2.48-2,2.63-3.52,1.51-6.26A85.65,85.65,0,0,0,132.19,184.56Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.3,76.58c1.15-30.93,12-52.91,35.76-67.14,26.78-16,59.8-11.19,81.83,11.14,26.33,26.68,28.46,70.81,4.41,99.58-16.75,20-38.39,29-64.27,24.22-26.58-4.87-44-21.45-53.09-46.57C65.11,90,64.31,81.41,63.3,76.58Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92,218.23c19.33-19.39,59.39-19.32,81.92.93l-27.13,29.33c-8.86-4.58-17.09-5.36-25.58-1.57a4.27,4.27,0,0,1-3.79-1C109,236.87,100.62,227.65,92,218.23Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.81,283.77c4.76-8.19,5.64-16.55,1.65-25.23a3.35,3.35,0,0,1,.56-3c9.13-9.08,18.37-18.06,27.84-27.32,10.8,14.35,15.63,29.92,13.93,47.37-.12,1.25-1.56,3.24-2.63,3.41-13.51,2.26-27.07,4.26-40.62,6.32Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.74,284.91c-10.33-1.09-19.63-2.05-28.92-3.07a59.59,59.59,0,0,1-6.37-1.06c-10-2.22-9.66.54-9.62-11.95,0-14.86,4.79-28.17,14.67-40.2,9.4,9.18,18.51,18.05,27.54,27a2.9,2.9,0,0,1,.6,2.56C105.38,267,106.44,275.5,111.74,284.91Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.64,282.37a12.66,12.66,0,1,1,12.62-12.71A12.76,12.76,0,0,1,132.64,282.37Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReAssignDriver);
export default __webpack_public_path__ + "static/media/ReAssign-driver.9a098c15cd7a8682f9ad8635cbf89784.svg";
export { ForwardRef as ReactComponent };